import { render, staticRenderFns } from "./AssistantToggleHeader.vue?vue&type=template&id=2fab3c5c&scoped=true"
import script from "./AssistantToggleHeader.vue?vue&type=script&lang=ts"
export * from "./AssistantToggleHeader.vue?vue&type=script&lang=ts"
import style0 from "./AssistantToggleHeader.vue?vue&type=style&index=0&id=2fab3c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab3c5c",
  null
  
)

export default component.exports